<!-- 웹에디터를 유스내비용 웹에디터로 연동 ( 어뎁터 )

  유스내비 웹에디터 (이상한;;) 특이사항
  1. v-model 의 value / input 을 content / getEditorInfo 로 바꿔서 사용
  2. @input 시 emit change {html: 에디터 내용}


buildv admin
buildv expinfoInsert
buildv expinfoUpdate
buildv mypageCenterQnaInsert
buildv mypageCenterQnaDetail

buildv homebase
buildv youth
buildv voice


 -->
<template>
  <section class="editor_tiny">
    <EditorTiny
      ref="ref_editor"
      :value="content"
      @input="onInput"
    />
  </section>
</template>
<script>
import EditorTiny from './editorTiny.vue'

export default {
  components: {EditorTiny},
  inheritAttrs: false,
  model: {
    prop:  'content',        // v-model 의 :value 를 content 로 변경
    event: 'getEditorInfo'   // v-model 의 @input 를 @getEditorInfo 로 변경
  },
  props: {
    content: String,
  },
  methods: {
    /** 에디터 내용 변경시 ( 유스내비 전용 )*/
    onInput: function(html) {
      if (html === '<p><br></p>') html = ''
      this.$emit('change', {html}) // {html, text, quill});
    },
  }
}
</script>
